import { ICON_CHOICES } from './icons';

const CardsSchema = (props) => ({
  title: 'AgSUS Cards (acesso)',
  fieldsets: [
    {
      id: 'default',
      title: 'Seção',
      fields: [
        'eyebrow',
        'title',
        'linkText',
        'linkHref',
        'columns',
        'variant',
        'fundo',
      ],
    },
    { id: 'items', title: 'Cards', fields: ['items'] },
  ],
  properties: {
    eyebrow: {
      title: 'Etiqueta',
      description: 'Texto curto em caixa alta, acima do título.',
    },
    title: { title: 'Título da seção' },
    linkText: {
      title: 'Texto do link à direita do título',
      description:
        'Opcional. Ex.: Veja todos os serviços. Aparece só com o texto e o endereço preenchidos.',
    },
    linkHref: {
      title: 'Endereço do link',
      description:
        'Página do site (ex.: /servicos) ou endereço externo (https://…).',
    },
    columns: {
      title: 'Colunas',
      choices: [
        ['2', '2'],
        ['3', '3'],
        ['4', '4'],
      ],
      default: '3',
    },
    variant: {
      title: 'Variação visual',
      choices: [
        ['cards', 'Cards'],
        ['links', 'Lista de links'],
        ['opportunities', 'Oportunidades (imagem + botão)'],
      ],
      default: 'cards',
    },
    fundo: {
      title: 'Fundo da seção',
      description:
        'Creme põe o bloco numa faixa de ponta a ponta, para destacá-lo na página.',
      choices: [
        ['branco', 'Branco (padrão)'],
        ['creme', 'Creme, de ponta a ponta'],
      ],
      default: 'branco',
    },
    items: {
      title: 'Cards',
      widget: 'object_list',
      schema: {
        title: 'Card',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: [
              'title',
              'body',
              'href',
              'imageUrl',
              'buttonLabel',
              'icon',
              'iconLabel',
            ],
          },
        ],
        properties: {
          title: { title: 'Título' },
          body: { title: 'Texto', widget: 'textarea' },
          href: { title: 'Link' },
          imageUrl: {
            title: 'Imagem',
            description:
              'URL da arte exibida no topo do card de oportunidades.',
          },
          buttonLabel: {
            title: 'Texto do botão',
            default: 'Acessar',
          },
          icon: {
            title: 'Ícone',
            description:
              'Selecione um ícone. Se vazio, usa as iniciais abaixo.',
            choices: ICON_CHOICES,
            default: '',
          },
          iconLabel: {
            title: 'Iniciais (fallback se sem ícone)',
            description:
              '1-2 letras no círculo quando nenhum ícone for selecionado.',
            default: 'AG',
          },
        },
        required: ['title'],
      },
    },
  },
  required: [],
});

export default CardsSchema;
